var React = require('react');

var ReactDOM = require('react-dom');

var InsuranceClauseDialog = React.createClass({
  propTypes: {
     pid: React.PropTypes.string,
     pname: React.PropTypes.string
  },


  getInitialState(){
     return {
         left: this.props.left
     }
  },

  openDialog(){
    var pid = this.props.pid;
    $.fancybox.open(
      {
        wrapCSS: 'track-poa-dialog ntrip-poa-dialog insurance-clause-dialog',
        title:"保险权益",
        type: "iframe",
        href: "//m.xcds.com.cn/topic/insurance-policy/?pid=" + pid,
        padding: 0,
        fitToView : false,
        width   : '800',
        height    : '545',
        autoSize  : false,
        helpers:{
          title: {
            type: 'inside',
            position: 'top'
          }
        }

      });

  },

  render(){
    return <a onClick={ this.openDialog } title="保险权益" className="attach-info-btn js-insurance-info">说明</a>;
  }
});

module.exports = InsuranceClauseDialog;



/** WEBPACK FOOTER **
 ** ./script/detail/InsuranceClauseDialog.jsx
 **/